import React from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

export default function MoodChart({ dailyLogs }) {
  const data = [...dailyLogs]
    .sort((a, b) => new Date(a.date) - new Date(b.date))
    .slice(-7)
    .map(log => ({
      date: log.date.slice(5), // MM-DD
      mood: log.mood,
    }));

  return (
    <div style={{ margin: "32px 0" }}>
      <h3>Your Mood This Week</h3>
      <ResponsiveContainer width="100%" height={220}>
        <LineChart data={data}>
          <XAxis dataKey="date" />
          <YAxis domain={[1, 5]} ticks={[1,2,3,4,5]} />
          <Tooltip />
          <Line type="monotone" dataKey="mood" stroke="#FFD166" strokeWidth={3} dot={{ r: 6 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
